export default function isTestMode() {
  const win = window as { CultureAmp?: { environment?: { test?: boolean } } };
  return (
    win.CultureAmp &&
    win.CultureAmp.environment &&
    win.CultureAmp.environment.test
  );
}
